import { ApiBaseService } from 'api/apibase.service';
import { PopularReview, Review } from 'api/reviews/types/review.interface';

class ReviewsApiService extends ApiBaseService {
  getReviews({
    productCode,
    offset,
    limit,
  }: {
    productCode: number;
    offset?: number;
    limit?: number;
  }): Promise<Review[]> {
    return this.apibase
      .get<Review[]>(`/arrangements/${productCode}/reviews`, {
        params: { offset, limit },
      })
      .then(({ data }) => data);
  }

  getPopularReviews(): Promise<PopularReview[]> {
    return this.apibase
      .get<PopularReview[]>('/reviews/popular-reviews')
      .then(({ data }) => data);
  }
}

export const reviewsApiService = new ReviewsApiService();
